import { createStyles, Theme } from '@material-ui/core';
import { createFileStyles } from '#web-components/components/Form/formioComponents/CustomFormioFile/CustomFile.styles';
import {
  createFieldSetStyles,
} from '#web-components/components/Form/formioComponents/CustomFieldSet/CustomFieldSet.styles';
import { createButtonStyles } from '#web-components/components/Form/formioComponents/CustomButton/CustomButton.styles';
import {
  createColumnsStyles,
} from '#web-components/components/Form/formioComponents/CustomColumns/CustomColumns.styles';
import { createTableStyles } from '#web-components/components/Form/formioComponents/CustomTable/CustomTable.styles';
import {
  createContentStyles,
} from '#web-components/components/Form/formioComponents/CustomContent/CustomContent.styles';

const styles = (theme: Theme) => createStyles({
  '@global': {
    ...createFileStyles(theme),
    ...createFieldSetStyles(theme),
    ...createButtonStyles(theme),
    ...createColumnsStyles(),
    ...createTableStyles(theme),
    ...createContentStyles(theme),
  },
});

export default styles;
